export default function initHero() {
    const hero = document.querySelector('[data-hero]');
    if (!hero) return;

    const top = hero.querySelector('[data-hero-top]');
    const bottom = hero.querySelector('[data-hero-bottom]');
    if (!top && !bottom) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let smoothed = 0;
    let ticking = false;

    const update = () => {
        const rect = hero.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        // progress 0 when section top touches viewport bottom, 1 when section bottom leaves top
        const total = rect.height + vh;
        const raw = Math.min(1, Math.max(0, (vh - rect.top) / total));
        // smoothing toward the raw value
        smoothed += (raw - smoothed) * 0.12;

        // map progress [0..1] → translateX:
        // top heading: +10% → -10%
        // bottom heading: -10% → +10%
        const topX = 10 - smoothed * 20;
        const botX = -10 + smoothed * 20;

        if (top) top.style.transform = `translate3d(${topX}%, 0, 0)`;
        if (bottom) bottom.style.transform = `translate3d(${botX}%, 0, 0)`;

        // keep animating while the section is near the viewport so smoothing can catch up
        if (Math.abs(raw - smoothed) > 0.001) {
            requestAnimationFrame(update);
        } else {
            ticking = false;
        }
    };

    const onScroll = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
}
